import type { OrderRow } from '../../../lib/types';
export const terminalStatuses = new Set(['completed', 'cancelled', 'rejected', 'delivery_failed']);
export const activeDeliveryStatuses = new Set(['accepted', 'purchasing_or_collecting', 'picked_up', 'on_the_way', 'delivered']);
export function matchesSearch(query: string, values: unknown[]) {
  const normalized = query.trim().toLocaleLowerCase();
  return !normalized || values.some(value => String(value ?? '').toLocaleLowerCase().includes(normalized));
}
export function filterOrders(orders: OrderRow[], search: string, status: string) {
  return orders.filter(order => (!status || order.status === status) && matchesSearch(search, [order.public_id, `PH-${String(order.public_id).padStart(5, '0')}`, order.pickup_name, order.dropoff_address, order.category, order.status]));
}
export function sumCentavos(values: number[]): number | null {
  let total = 0;
  for (const value of values) { if (!Number.isSafeInteger(value) || !Number.isSafeInteger(total + value)) return null; total += value; }
  return total;
}
export function auditDateBounds(start: string, end: string): { start?: string; end?: string; issue?: string } {
  const valid = (day: string) => /^\d{4}-\d{2}-\d{2}$/.test(day) && !Number.isNaN(Date.parse(day + 'T00:00:00+08:00')) && new Date(day + 'T00:00:00Z').toISOString().slice(0, 10) === day;
  if ((start && !valid(start)) || (end && !valid(end)) || (start && end && start > end)) return { issue: 'Choose valid dates with the end on or after the start.' };
  return { ...(start ? { start: new Date(start + 'T00:00:00+08:00').toISOString() } : {}), ...(end ? { end: new Date(Date.parse(end + 'T00:00:00+08:00') + 86_400_000).toISOString() } : {}) };
}
export function safeAuditMetadata(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(safeAuditMetadata);
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, /token|password|secret|authorization|signed.?url/i.test(key) ? '[redacted]' : safeAuditMetadata(entry)]));
  return value;
}
